import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b3111e5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "introduce-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "cr1" }, "标签分类", -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "tj-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { shadow: "hover" }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_el_divider),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (item, index) => {
          return (_openBlock(), _createElementBlock("p", {
            class: _normalizeClass([{ activeP: _ctx.active === index && !_ctx.isShows }, "fz cr3 cp"]),
            key: index,
            onClick: ($event: any) => (_ctx.categoryFn(index, item))
          }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(index), 1),
            _createVNode(_component_el_divider, { "border-style": "dashed" }),
            _createElementVNode("span", null, " (" + _toDisplayString(item.length) + "篇) ", 1)
          ], 10, _hoisted_3))
        }), 128))
      ]),
      _: 1
    })
  ]))
}